export enum SampleState {
    CREATED = 'CREATED',
    PUBLISHED = 'PUBLISHED',
    APPROVAL_REQUESTED = 'APPROVAL_REQUESTED',
    CHANGE_REQUESTED = 'CHANGE_REQUESTED',
    APPROVED_BY_REVIEWER = 'APPROVED_BY_REVIEWER',
    IN_PRODUCTION = 'IN_PRODUCTION',
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED'
}
